export default class FilterListStorage {
  valuesList = [];

  getItemValue = (item) => {
    if (item && typeof item === 'object') {
      return item.value ?? item.id;
    }
    return item;
  };

  hasValue = (id) => {
    return (this.valuesList || []).some((el) => id == this.getItemValue(el));
  };

  filterAvailableValues = (values) => {
    const normalized = Array.isArray(values) ? values : values == null || values === '' ? [] : [values];
    // Query params arrive as strings ("1"), so return the option's own value (1) to keep
    // strict comparisons in forms working and avoid duplicates like ["1", 1].
    return normalized.reduce((result, value) => {
      const item = (this.valuesList || []).find((el) => value == this.getItemValue(el));
      if (!item) {
        return result;
      }
      const itemValue = this.getItemValue(item);
      if (!result.some((existing) => existing == itemValue)) {
        result.push(itemValue);
      }
      return result;
    }, []);
  };

  // Unlike filterAvailableValues, keeps values missing from the list: searchers load only a
  // page of options, so an id from the URL may be valid without being loaded yet.
  normalizeValues = (values) => {
    if (!Array.isArray(values)) {
      return this.#toItemValue(values);
    }
    return values.reduce((result, value) => {
      const itemValue = this.#toItemValue(value);
      if (!result.some((existing) => existing == itemValue)) {
        result.push(itemValue);
      }
      return result;
    }, []);
  };

  #toItemValue = (value) => {
    if (value == null || value === '') {
      return value;
    }
    const item = (this.valuesList || []).find((el) => value == this.getItemValue(el));
    return item ? this.getItemValue(item) : value;
  };

  getValueLabel = (id) => {
    const item = (this.valuesList || []).find((el) => id == this.getItemValue(el));
    if (item) {
      if (item.cat) {
        return `${item.name} (${item.cat})`;
      } else {
        return item.name || item.text;
      }
    } else {
      return `id:${id}`;
    }
  };

  setValuesList(valuesList) {
    this.valuesList = valuesList || [];
  }

  addToValuesList(item) {
    this.valuesList.push(item);
  }
}
